;
//# sourceMappingURL=global.store.interface.js.map